// Mirror of apps/backend/src/config/competitionLimits.ts — keep in sync.
export const COMPETITION_LIMITS = {
  MAX_COMPETITIONS_PER_USER: 10,
  MAX_PLAYERS_PER_COMPETITION: 64,
  MIN_PLAYERS_TO_DRAW: 6,
  INVITE_CODE_LENGTH: 8,
  MAX_NAME_LENGTH: 100,
  MAX_DESCRIPTION_LENGTH: 500,
  MIN_TEAMS_PER_GROUP: 3,
  MAX_TEAMS_PER_GROUP: 4,
  MIN_TEAMS_ADVANCING: 1,
  MAX_TEAMS_ADVANCING: 2,
};
